// src/pages/VerifyEmail.jsx
import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  Snackbar,
  Alert,
} from "@mui/material";
import { useSearchParams, useNavigate } from "react-router-dom";
import API from "../api";
import { setAuth } from "../utils/auth";

const VerifyEmail = () => {
  const [params] = useSearchParams();
  const email = params.get("email") || "";
  const [code, setCode] = useState("");
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const navigate = useNavigate();

  const show = (msg, sev = "error") =>
    setSnack({ open: true, message: msg, severity: sev });

  const handleVerify = async () => {
    if (!code) return show("Enter the code");
    try {
      const { data } = await API.post("/verify-email", { email, code });
      setAuth(data.token, data.role);
      show("Verified! Redirecting...", "success");
      setTimeout(() => navigate(`/${data.role}`), 800);
    } catch (err) {
      show(err.response?.data?.message || "Verification failed");
    }
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="#f5f5f5"
    >
      <Paper elevation={4} sx={{ p: 4, width: 360 }}>
        <Typography variant="h5" align="center" mb={2}>
          Verify Your Email
        </Typography>
        <Typography align="center" mb={3}>
          Code sent to <b>{email}</b>
        </Typography>

        <TextField
          fullWidth
          label="Verification Code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          sx={{ mb: 3 }}
        />

        <Button fullWidth variant="contained" onClick={handleVerify}>
          Verify & Continue
        </Button>
      </Paper>

      <Snackbar
        open={snack.open}
        autoHideDuration={3000}
        onClose={() => setSnack((s) => ({ ...s, open: false }))}
      >
        <Alert severity={snack.severity}>{snack.message}</Alert>
      </Snackbar>
    </Box>
  );
};

export default VerifyEmail;
